export const MODULE_NAMES = {
    ESTADOS_REDUCIDOS_PEDIDOS: 'ESTADOS REDUCIDOS PEDIDOS',
    CARTA_DISPONIBLE: 'CARTA DISPONIBLE',
    SEGUIR_MI_PEDIDO: 'SEGUIR MI PEDIDO',
    CLIENT: 'CLIENT',
    PROVIDER: 'PROVIDER',
};

export const CONTACT_SUPPORT_MESSAGE =
    'Para activar este módulo, solicitá la habilitación a nuestro equipo.';

export const isModuleActive = (features = [], moduleName, defaultValue = false) => {
    const feature = features.find((item) => item.name === moduleName);
    if (!feature) {
        return defaultValue;
    }
    return feature.status === true || feature.status === 1;
};

export const MODULE_DEFINITIONS = {
    'MODULO BASICO': {
        label: 'Módulo básico',
        description: 'Funcionalidades esenciales de pedidos y catálogo.',
        locked: true,
        hidden: true,
        priority: 0,
    },
    STOCK: {
        label: 'Stock',
        description: 'Control de inventario y movimientos.',
        priority: 10,
    },
    CLIENT: {
        label: 'Clientes',
        description: 'Gestión de clientes y cuentas corrientes.',
        priority: 11,
    },
    PROVIDER: {
        label: 'Proveedores',
        description: 'Gestión de proveedores, cuentas corrientes y pedidos a proveedores.',
        priority: 12,
    },
    REPORTES: {
        label: 'Reportes',
        description: 'Acceso a reportes y movimientos.',
        priority: 13,
    },
    'VENCIMIENTOS DE PRODUCTOS': {
        label: 'Vencimientos de productos',
        description: 'Control de vencimientos en el catálogo.',
        priority: 14,
    },
    FACTURACION: {
        label: 'Facturación',
        description: 'Emisión de comprobantes fiscales.',
        locked: true,
        contactMessage: CONTACT_SUPPORT_MESSAGE,
        priority: 15,
    },
    'CONFIGURACION EXTENDIDA': {
        label: 'Configuración extendida',
        description: 'Opciones avanzadas de configuración.',
        locked: true,
        contactMessage: CONTACT_SUPPORT_MESSAGE,
        priority: 16,
    },
    GEOLOCALIZACION: {
        label: 'Geolocalización',
        description: 'Validación de direcciones con mapas.',
        locked: true,
        contactMessage: CONTACT_SUPPORT_MESSAGE,
        priority: 17,
    },
    'PAGOS MERCADO PAGO': {
        label: 'Pagos Mercado Pago',
        description: 'Integración de cobros con Mercado Pago.',
        locked: true,
        contactMessage: CONTACT_SUPPORT_MESSAGE,
        priority: 18,
    },
    'PEDIDOS CAJA': {
        label: 'Pedidos caja',
        description: 'Punto de venta y pedidos de caja.',
        priority: 19,
    },
    'ESTADOS REDUCIDOS PEDIDOS': {
        label: 'Estados reducidos de pedidos',
        description: 'Usa solo Recibido, Finalizado y Cancelado en la gestión de pedidos.',
        priority: 20,
    },
    PROMOCIONES: {
        label: 'Promociones',
        description: 'Descuentos y promociones en productos.',
        priority: 21,
    },
    'ETIQUETA PRECIO': {
        label: 'Etiquetas de precio',
        description: 'Impresión de etiquetas con precios.',
        priority: 22,
    },
    'REGISTRO CAJA': {
        label: 'Registro de caja',
        description: 'Apertura, cierre e historial de caja.',
        priority: 23,
    },
    'CARTA DISPONIBLE': {
        label: 'Carta disponible',
        description: 'Permite el acceso público a la carta digital.',
        priority: 24,
    },
    'SEGUIR MI PEDIDO': {
        label: 'Pantalla Seguir mi pedido',
        description: 'Muestra el botón en la carta y habilita la consulta de estado del pedido.',
        priority: 25,
    },
    'TICKET 58MM': {
        label: 'Ticket 58 mm',
        description: 'Usa el template de ticket para rollo térmico de 58 mm.',
        hidden: true,
        priority: 26,
    },
    'ZONA RURAL': {
        label: 'Zona rural',
        description: 'Envíos y precios para zonas rurales.',
        priority: 30,
    },
    'PEDIDO MOZO': {
        label: 'Pedido mozo',
        description: 'Pedidos asistidos por personal de salón.',
        priority: 32,
    },
    'PEDIDOS MESA': {
        label: 'Pedidos mesa',
        description: 'Pedidos desde mesas del local.',
        hidden: true,
        priority: 40,
    },
    CUENTA_CORRIENTE_CLIENT: {
        label: 'Cuenta corriente clientes',
        description: 'Cuentas corrientes para clientes.',
        hidden: true,
        priority: 50,
    },
    CUENTA_CORRIENTE_PROVIDER: {
        label: 'Cuenta corriente proveedores',
        description: 'Cuentas corrientes para proveedores.',
        hidden: true,
        priority: 51,
    },
    'PEDIDOS PROVEEDOR': {
        label: 'Pedidos a proveedores',
        description: 'Gestión de pedidos a proveedores.',
        hidden: true,
        priority: 52,
    },
};

export const isClientModuleActive = (features = []) =>
    isModuleActive(features, MODULE_NAMES.CLIENT);

export const isProviderModuleActive = (features = []) =>
    isModuleActive(features, MODULE_NAMES.PROVIDER);

export const getModuleLabel = (moduleName) =>
    MODULE_DEFINITIONS[moduleName]?.label || moduleName;

export const getModuleDescription = (moduleName) =>
    MODULE_DEFINITIONS[moduleName]?.description || 'Módulo del sistema.';

export const isModuleLocked = (moduleName) =>
    MODULE_DEFINITIONS[moduleName]?.locked === true;

export const isModuleHidden = (moduleName) =>
    MODULE_DEFINITIONS[moduleName]?.hidden === true;

export const getModuleContactMessage = (moduleName) =>
    MODULE_DEFINITIONS[moduleName]?.contactMessage || null;

export const filterModulesForSystemConfig = (modules = []) =>
    modules.filter((module) => !isModuleHidden(module.name));

export const sortModulesForDisplay = (modules = []) =>
    [...modules].sort((left, right) => {
        const leftPriority = MODULE_DEFINITIONS[left.name]?.priority ?? 100;
        const rightPriority = MODULE_DEFINITIONS[right.name]?.priority ?? 100;
        if (leftPriority !== rightPriority) {
            return leftPriority - rightPriority;
        }
        return getModuleLabel(left.name).localeCompare(getModuleLabel(right.name), 'es');
    });
